import { CognitoUserPool } from 'amazon-cognito-identity-js'
export const poolData = {
  UserPoolId: process.env.NODE_ENV === 'development' ? 'eu-central-1_XSg71Kju0' : 'eu-central-1_gFSYW5HWp',
  ClientId: process.env.NODE_ENV === 'development' ? '99o7046pknklngru096r453ia' : '7ovnl8i8ggq54rasjcf4tmjt03',
  Domain:
    process.env.NODE_ENV === 'development'
      ? 'https://estigroup-dealers-test.auth.eu-central-1.amazoncognito.com'
      : 'https://estigroup-dealers.auth.eu-central-1.amazoncognito.com',
  RedirectUri:
    process.env.NODE_ENV === 'development'
      ? 'http://localhost:3001/auth/callback'
      : 'https://dealers.estigroup.de/auth/callback'
}

export default new CognitoUserPool(poolData)
